export default __webpack_public_path__ + "static/media/SENAIT_NL_EPILOGFIN1.b6cbd784.mp3";